// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-15ec7b22]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#c41230;redBright:#eb1700}.footer-text-tremfy[data-v-15ec7b22]{font-size:17px;line-height:1;font-family:KarbonWeb-Regular;width:850px}.footer-text p[data-v-15ec7b22]{margin:0}", ""]);
// Exports
module.exports = exports;
